import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

import { deactivateAccount, activateAccount } from '../utils/Api';

import { Modal } from 'react-bootstrap';

const redirectToViewClient = (navigate, client) => {
    localStorage.setItem('clientName', client['clientName']);
    navigate(`/view-client/${client['customerId']}`);
}

function PlatformClient({ client, onUpdateEvent }) {
    const [deactivateActionShow, setDeactivateActionShow] = useState(false);
    const [activateActionShow, setActivateActionShow] = useState(false);

    const deactivateHandleClose = () => setDeactivateActionShow(false);
    const deactivateHandleShow = () => setDeactivateActionShow(true);
    const activateHandleClose = () => setActivateActionShow(false);
    const activateHandleShow = () => setActivateActionShow(true);

    const navigate = useNavigate();

    const deactiveAccountProcess = async (id, setDeactivateActionShow) => {
        let accountDeactivated = await deactivateAccount(id);

        if (!accountDeactivated) {
            return;
        }
        toast.info('Account deactivated successfully');
        setDeactivateActionShow(false);
        onUpdateEvent(true);
    }

    const activeAccountProcess = async (id, setActivateActionShow) => {
        let accountActivated = await activateAccount(id);

        if (!accountActivated) {
            return;
        }
        toast.info('Account activated successfully');
        setActivateActionShow(false);
        onUpdateEvent(true);
    }

    return (
        <tr className='table-content border-bottom'>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['accountName']}</td>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['clientName']}</td>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['adminName']}</td>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['totalLicense']}</td>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['activeLicense']}</td>
            <td className='p-3 text-center' onClick={() => redirectToViewClient(navigate, client)}>{client['status'] == true ? 'Active' : 'Inactive'}</td>
            <td className='p-3 text-center'>
                {client['status'] == true ?
                    <button className='deactivate-button p-2 px-3' onClick={deactivateHandleShow}>Deactivate</button>
                    :
                    <button className='activate-button p-2 px-3' onClick={activateHandleShow}>Activate</button>
                }
            </td>
            <td className='p-3 text-center'>
                <button className='send-button p-2 px-4'>Send</button>
            </td>
            <>
                <Modal className='activation-modal' show={deactivateActionShow} onHide={deactivateHandleClose}>
                    <Modal.Body>
                        <Modal.Title className='status-modal-title text-center'>Confirm Action</Modal.Title>
                        <div className='status-modal-sub-title mt-4 text-center'>Are you sure you want to deactivate the client, {client['clientName']}?</div>

                        <div className='d-flex justify-content-end mt-5'>
                            <button className='cancel-button p-2 px-4 me-3' onClick={deactivateHandleClose}>Cancel</button>
                            <button className='save-button p-2 px-4' onClick={() => deactiveAccountProcess(client['customerId'], setDeactivateActionShow)}>Deactivate</button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal className='activation-modal' show={activateActionShow} onHide={activateHandleClose}>
                    <Modal.Body>
                        <Modal.Title className='status-modal-title text-center'>Confirm Action</Modal.Title>
                        <div className='status-modal-sub-title mt-4 text-center'>Are you sure you want to activate the client, {client['clientName']}?</div>

                        <div className='d-flex justify-content-end mt-5'>
                            <button className='cancel-button p-2 px-4 me-3' onClick={activateHandleClose}>Cancel</button>
                            <button className='save-button p-2 px-4' onClick={() => activeAccountProcess(client['customerId'], setActivateActionShow)}>Activate</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        </tr>
    )
}

export default PlatformClient